import type { Selectors, MiddlewareManager } from '@makemydeal/activities-credit-app';
import { init } from '@makemydeal/activities-credit-app';
import { additionalSelectors } from './additionalSelectors';

let creditAppSelectors: Selectors;
let creditAppMiddlewareManager: MiddlewareManager;

export const configureCreditApp = (): { selectors: Selectors; middlewareManager: MiddlewareManager } => {
    const { selectors, middlewareManager } = init(additionalSelectors);
    creditAppSelectors = selectors;
    creditAppMiddlewareManager = middlewareManager;
    return { selectors, middlewareManager };
};

export const getCreditAppSelectors = (): Selectors => creditAppSelectors;
export const getCreditAppMiddlewareManager = (): MiddlewareManager => creditAppMiddlewareManager;
